import React, { useState } from 'react'
import {
  Badge,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material'
import CommentIcon from '@mui/icons-material/Comment'
import CloseIcon from '@mui/icons-material/Close'
import { VoucherType } from '../../types'
import VoucherComments from '../Vouchers/VoucherComments'

type VoucherCommentsBadgeProps = {
  voucher: VoucherType
}

const VoucherCommentsBadge: React.FC<VoucherCommentsBadgeProps> = ({
  voucher,
}) => {
  const [open, setOpen] = useState(false)

  const handleOpen = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    setOpen(true)
  }

  const handleClose = (e?: any) => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault()
    }
    if (e && typeof e.stopPropagation === 'function') {
      e.stopPropagation()
    }
    setOpen(false)
  }

  if (!open && (!voucher.comments || voucher.comments.length === 0)) return null

  return (
    <>
      <Tooltip title={`Voucher has ${voucher.comments?.length || 0} comments`}>
        <span onClick={handleOpen} style={{ cursor: 'pointer' }}>
          <Badge
            badgeContent={voucher.comments?.length || 0}
            color="primary"
            sx={{ ml: 2 }}
          >
            <CommentIcon color="action" fontSize="small" />
          </Badge>
        </span>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        onClick={(e) => e.stopPropagation()}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          Voucher# {voucher.reference_number} - Comments
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <VoucherComments voucher={voucher} hideTitle />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default VoucherCommentsBadge
